import {
    ExamList,
    SendVerificationCodeForAcceptExamInvite,
    AcceptExamInvite,
    VerificationCodeSendingStatus,
} from '../../api/ApiClient';
import { INotification } from 'components';
import { createModel } from '@rematch/core';
import apiConnector from '../../api/ApiConnector';

const initialState: IState = {
    requestsList: null,
    smsCodeStatus: null,
};

export default createModel({
    state: initialState,
    reducers: {
        setList(state, requestsList: ExamList) {
            return { ...state, requestsList };
        },
        setSmsCodeStatus(state, smsCodeStatus: VerificationCodeSendingStatus | null) {
            return { ...state, smsCodeStatus };
        },
    },
    effects: (dispatch: any) => ({
        async fetchRequests(payload: FetchExamApplicationsDetails) {
            dispatch.requests.setList(await apiConnector.execApi(
              dispatch,
              api => api.getExamInvites(
                payload.page,
                payload.pageSize,
                payload.sortOrder,
                payload.sortField,
              ),
            ));
        },
        async sendCodeForAcceptExamInvite({ examId, captcha }: ISendCode) {
            const smsCodeStatus = await apiConnector.execApi(
              dispatch,
              api => api.sendCodeForAcceptExamInvite(examId, new SendVerificationCodeForAcceptExamInvite({ captcha })),
            );

            if (smsCodeStatus) {
                dispatch.notifications.addNotification([{ message: 'Код успешно отправлен!', appearance: 'success' }] as INotification[]);
            }
            this.setSmsCodeStatus(smsCodeStatus);
        },
        async acceptExamInvite({ examId, code, captcha }: IAcceptInvite) {
            const result = await apiConnector.execApi(dispatch, api => api.acceptExamInvite(examId, new AcceptExamInvite({ code, captcha })));
            if (result) {
                dispatch.notifications.addNotification([{ message: 'Участие в экзамене успешно подтверждено!', appearance: 'success' }] as INotification[]);
            }

            return result;
        },
        async rejectExamInvite(examId: string) {
            const result = await apiConnector.execApi(dispatch, api => api.rejectExamInvite(examId));
            if (result) {
                dispatch.notifications.addNotification([{ message: 'Участие в экзамене успешно отклонено!', appearance: 'success' }] as INotification[]);
            }
            return result;
        },
    }),
});

interface IState {
    requestsList: ExamList | null;
    smsCodeStatus: VerificationCodeSendingStatus | null;
}

interface IAcceptInvite {
    examId: string;
    code: string;
    captcha?: string;
}

interface ISendCode {
    examId: string;
    captcha?: string;
}

interface FetchExamApplicationsDetails {
    page: number | undefined;
    pageSize: number | undefined;
    sortOrder: boolean | undefined;
    sortField: string | undefined;
}
